import {
  type AppKitNetwork,
  arbitrum,
  base,
  berachain,
  blast,
  bsc,
  fraxtal,
  linea,
  localhost,
  lyra,
  mainnet,
  manta,
  mantle,
  metis,
  mode,
  optimism,
  scroll,
  zksync,
} from '@reown/appkit/networks'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'

import { kinto } from '../components/kinto'
import { IS_TESTING } from '../constants/is-testing'
import { TRANSPORTS } from '../constants/transports'

import { hyperliquid } from './chains'

const projectId = process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID ?? ''

export const chains = [
  mainnet,
  berachain,
  mantle,
  arbitrum,
  base,
  bsc,
  optimism,
  lyra,
  zksync,
  fraxtal,
  linea,
  mode,
  kinto,
  blast,
  manta,
  scroll,
  metis,
  hyperliquid,
] as [AppKitNetwork, ...AppKitNetwork[]]

if (IS_TESTING) {
  chains.unshift(localhost)
}

export const wagmiAdapter = new WagmiAdapter({
  networks: chains,
  projectId,
  ssr: true,
  transports: TRANSPORTS,
})
